import { Download, ChevronDown } from 'lucide-react';
import React, { useState, useRef, useEffect } from "react";

const TransactionsToCsv = ({ transactions, isMobile, onExport }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const exportCSV = (filterType) => {
    const headers = ["Date", "Time", "Transaction ID", "Description", "Amount", "Type", "Category"];

    const filtered = transactions.filter(txn => {
      if (filterType === "all") return true;
      return txn.type === filterType;
    });

    const rows = filtered.map(txn => [
      txn.date,
      txn.time,
      `"${txn.id}"`, 
      txn.description,
      txn.amount.toFixed(2),
      txn.type,
      txn.category
    ]);

    const csvContent = [
      headers.join(","),
      ...rows.map(row => row.map(val => `"${val}"`).join(","))
    ].join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `${filterType}_transactions.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleExportClick = (filter) => {
    exportCSV(filter);
    setIsOpen(false);
    if (onExport) {
      onExport(); 
    }
  };

  if (isMobile) {
    return (
      <>
        <div className="px-3 py-2 text-xs font-bold text-gray-400 uppercase">Export</div>
        <div
          onClick={() => handleExportClick("all")}
          className="flex items-center gap-3 px-3 py-2 text-sm text-gray-700 hover:bg-gray-100 cursor-pointer rounded-md"
        >
          <Download size={16} className="text-gray-500" />
          <span>Export All</span>
        </div>
        <div
          onClick={() => handleExportClick("income")}
          className="flex items-center gap-3 px-3 py-2 text-sm text-gray-700 hover:bg-gray-100 cursor-pointer rounded-md"
        >
          <Download size={16} className="text-green-500" />
          <span>Export Income</span>
        </div>
        <div
          onClick={() => handleExportClick("expense")}
          className="flex items-center gap-3 px-3 py-2 text-sm text-gray-700 hover:bg-gray-100 cursor-pointer rounded-md"
        >
          <Download size={16} className="text-red-500" />
          <span>Export Expenses</span>
        </div>
      </>
    );
  }

  return (
    <div className="relative inline-block text-left" ref={dropdownRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 px-4 py-2 bg-white text-[#2ecfe3] border-2 border-[#2ecfe3] font-semibold rounded-lg shadow-sm hover:bg-[#eafcff] hover:shadow-md transition-all duration-200"
      >
        Export CSV
        <ChevronDown size={18} className={`transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} />
      </button>

      {isOpen && (
        <div className="absolute right-0 mt-2 w-48 bg-white border border-gray-200 rounded-lg shadow-xl z-20 overflow-hidden">
          <div
            onClick={() => handleExportClick("all")}
            className="flex items-center gap-3 w-full px-4 py-2.5 text-left text-sm text-gray-700 hover:bg-gray-100 cursor-pointer transition-colors"
          >
            <Download size={16} className="text-gray-500"/>
            Export All
          </div>
          <div
            onClick={() => handleExportClick("income")}
            className="flex items-center gap-3 w-full px-4 py-2.5 text-left text-sm text-gray-700 hover:bg-gray-100 cursor-pointer transition-colors"
          >
            <Download size={16} className="text-green-500"/>
            Export Income
          </div>
          <div
            onClick={() => handleExportClick("expense")}
            className="flex items-center gap-3 w-full px-4 py-2.5 text-left text-sm text-gray-700 hover:bg-gray-100 cursor-pointer transition-colors"
          >
            <Download size={16} className="text-red-500"/>
            Export Expenses
          </div>
        </div>
      )}
    </div>
  );
};

export default TransactionsToCsv;